module.exports = __webpack_public_path__ + "static/flags/AZ-a853c6b50fb843d1deae364adfbce0c1.gif";